import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import RoutesFile from './views/routes/Routes'
import ConfigLoader from './configs/ConfigLoader'
import AppConfigContext from './app/AppConfigContext'

const container = document.getElementById('root')
const root = ReactDOM.createRoot(container)
root.render(
  <ConfigLoader
    ready={(config) => (
      <React.StrictMode>
        <AppConfigContext.Provider value={config}>
          <BrowserRouter>
            <RoutesFile />
          </BrowserRouter>
        </AppConfigContext.Provider>
      </React.StrictMode>
    )}
  />
)
